import React from 'react';
import css from './MentorshipFormFields.module.css';
import { FormattedMessage } from 'react-intl';

import TitleInputField from '../TitleInputField';
import PriceInputField from '../PriceInputField';
import HoursInputField from '../HoursInputField';
import LocationInputFormField from '../LocationInputFormField/LocationInputFormField';
import SpecificSkillsFormField from '../SpecificSkillsFormField/SpecificSkillsFormField';
import PersonalizationFormField from '../PersonalizationFormField';
import BookingTimeFormField from '../BookingTimeFormField/BookingTimeFormField';
import classNames from 'classnames';

const MENTORSHIP_CONFIG = {
  'Mentorship Discussion': {
    needsLocation: false,
    needsSkillsField: false,
    descriptionLabel: 'What is your goal for the Mentorship?',
    descriptionPlaceholder:
      'e.g. I want to learn how to transition from college to pro, manage time, or build confidence...',
  },
  'Skill Development': {
    needsLocation: true,
    needsSkillsField: true,
  },
  'Career Development Mentorship': {
    needsLocation: true,
    needsSkillsField: true,
  },
  'Athlete Branding Consultation': {
    needsLocation: true,
    needsSkillsField: true,
  },
  'Mental Toughness Coaching': {
    needsLocation: true,
    needsSkillsField: true,
  },
  'Sponsorship Consultation': {
    needsLocation: true,
    needsSkillsField: true,
  },
};

const MentorshipFormFields = ({ formId, values, listing }) => {
  const selectedTitle = values?.title;
  const config = selectedTitle ? MENTORSHIP_CONFIG[selectedTitle] : null;

  // Show only title + price until type is selected
  if (!selectedTitle || !config) {
    return (
      <>
        <div className={css.offeringBlock}>
          <div className={css.offeringHeader}>
            <h4>
              <FormattedMessage id="MentorshipFormFields.sectionHeading" />
            </h4>
          </div>
        </div>
        <div className={css.formRow}>
          <div className={css.formFld}>
            <TitleInputField label="Title" id="title" fieldName="title" />
          </div>
          <div className={css.formFld}>
            <PriceInputField formId={formId} />
          </div>
        </div>
      </>
    );
  }

  const {
    needsLocation,
    needsSkillsField,
    descriptionLabel = 'What specific skills or topics are you looking to develop?',
    descriptionPlaceholder = 'e.g. Free throw consistency, first-step quickness, leadership under pressure...',
  } = config;

  return (
    <>
      <div className={css.offeringBlock}>
        <div className={css.offeringHeader}>
          <h4>
            <FormattedMessage id="MentorshipFormFields.sectionHeading" />
          </h4>
        </div>
      </div>

      <div className={css.formRow}>
        <div className={css.formFld}>
          {/* Title */}
          <TitleInputField label="Title" id="title" fieldName="title" />
        </div>
        <div className={css.formFld}>
          {/* Price */}
          <PriceInputField formId={formId} />
        </div>
      </div>

      <div className={css.formRow}>
        <div className={css.formFld}>
          {/* Hours */}
          <HoursInputField
            label="How many hours?"
            fieldName="hours"
            id="hours"
            placeholder="e.g. 2 hours"
          />
        </div>
      </div>
      {/* Booking Time */}
      <BookingTimeFormField listing={listing} />

      <div className={classNames(css.formRow, css.fullWidth)}>
        <div className={classNames(css.formFld, css.fieldGroup)}>
          {/* Location - Only for in-person mentorships */}
          {needsLocation && (
            <LocationInputFormField
              fieldName="location"
              label="Location"
              placeholder="Gym, office, or facility where the session will take place"
            />
          )}
        </div>
      </div>

      {/* Special Case: Mentorship Discussion → Simple text goal */}
      {selectedTitle === 'Mentorship Discussion' && (
        <PersonalizationFormField
          label={descriptionLabel}
          placeholder={descriptionPlaceholder}
          fieldName="mentorshipGoal"
          rows={6}
        />
      )}

      {/* All others → Specific Skills multi-input */}
      {needsSkillsField && <SpecificSkillsFormField />}

      {/* Optional note for virtual/remote */}
      {!needsLocation && selectedTitle === 'Mentorship Discussion' && (
        <div className={css.infoNote}>
          <p>
            <strong>
              <FormattedMessage id="MentorshipFormFields.virtualOrPhoneDiscussionNotePrefix" />
            </strong>{' '}
            <FormattedMessage id="MentorshipFormFields.virtualOrPhoneDiscussionNoteText" />
          </p>
        </div>
      )}
    </>
  );
};

export default MentorshipFormFields;
